import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'app-custom-toast',
  standalone: false,
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
  animations: []
})
export class CustomToastComponent extends Toast {
  
  get toastType(): string {
    return this.toastPackage.toastType;
  }
  get autoTitle(): string {
  const titles: Record<string, string> = {
    'toast-success': 'Success',
    'toast-error': 'Error',
    'toast-warning': 'Warning',
    'toast-info': 'Info'
  };
  return titles[this.toastType] || '';
}
}